import api from "../util/api";
import { createAsyncThunk } from "@reduxjs/toolkit";
import { BuscarSaldoConsignatarioModel } from "../models/lancamentoConsignatario/buscarSaldoConsignatarioModel";
import { BuscaAnexoConsignatarioModel } from "../models/lancamentoConsignatario/buscaAnexosConsignatario";
import { BuscarSaldoInicioFimConsignatarioModel } from "../models/lancamentoConsignatario/BuscarSaldoInicioFimConsignatarioModel";
import { setLoading } from "../redux/slices/configuracoes/configuracoesSlice";
import { toastError, toastSucess } from "../util/toast";
import { listarNotasFiscais } from "./notasFiscaisService";
import { buscarAnexosVendaConsignatario, buscarVendaConsignatario } from "./vendaConsignatarioService";
import { setModalCadastrarNotasFiscais } from "../redux/slices/notasfiscais/notasFiscaisSlice";
import { PrestacaoContaModel } from "../models/prestacaoConta/prestacaoContaModel";
import { BuscaUrlPreAssinada } from "../models/arquivoAnexo/chamadas/buscaUrlPreAssinada";

export const cadastrarPrestacaoContaConsignatario = createAsyncThunk(
  "/PrestacaoContaConsignatario/CadastrarPrestacaoContaConsignatario",
  async (payload: { value: PrestacaoContaModel; busca:any; buscaAnexoPrestacao: any; buscaAnexoVenda: any; buscaVenda: any; origem: string }, { dispatch }) => {
    try {
      dispatch(setLoading(true));
      var arquivoJson: any[] = [];

      for (const v of payload.value.prestacaoContaConsignatario) {
        if (typeof v.caminhoArquivo !== "string") {
          //recuperar url
          let buscaUrl: BuscaUrlPreAssinada = {
            fileName: v.nome,
            contentType: v.extensaoArquivo!,
          };

          const retorno = await api.get("/ArquivoAnexo/presigned-url", {
            params: { fileName: buscaUrl.fileName, contentType: buscaUrl.contentType },
          });

          const uploadRes = await fetch(retorno.data.data.url, {
            method: "PUT",
            headers: {
              "Content-Type": v.extensaoArquivo!,
              "x-amz-acl": "public-read",
            },
            body: v.caminhoArquivo,
          });

          if (!uploadRes.ok) {
            toastError("Ocorreu um erro ao fazer o upload do arquivo");
            throw new Error("Erro ao fazer upload para o S3");
          }

          const fileUrl = retorno.data.data.url.split("?")[0];

          var detalhes = {
            caminhoArquivo: fileUrl,

            extensaoArquivo: v.extensaoArquivo,
            idTipoArquivoAnexo: v.idTipoArquivoAnexo,
            nome: v.nome,
            valor: v.valor,
            numeroNotaFiscal: v.numeroNotaFiscal,
          };

          arquivoJson.push(detalhes);
        } else {
          arquivoJson.push(v);
        }
      }

      payload.value.prestacaoContaConsignatario = arquivoJson;

      await api.post("/PrestacaoContaConsignatario/CadastrarPrestacaoContaConsignatario/", payload.value);
      toastSucess("Anexos adicionados com sucesso");
      dispatch(setLoading(false));
      if (payload.origem === "notasFiscais") {
        dispatch(setModalCadastrarNotasFiscais(false));
        dispatch(listarNotasFiscais(payload.busca));
      } else {
        dispatch(listarAnexosPrestacaoContaConsignatario(payload.buscaAnexoPrestacao));
        dispatch(buscarAnexosVendaConsignatario(payload.buscaAnexoVenda));
        dispatch(buscarVendaConsignatario(payload.buscaVenda));
      }
    } catch (error: any) {
      dispatch(setLoading(false));
      toastError(error.response.data.Message.includes("UNIQUE") ? "Já existe uma número da NF para esse Consignatário" : error.response.data.Message);
    }
  }
);

export const listarSaldoConsignatario = createAsyncThunk("/PrestacaoContaConsignatario/ListarSaldoConsignatario", async (args: BuscarSaldoConsignatarioModel) => {
  try {
    const data = await api.get("/PrestacaoContaConsignatario/ListarSaldoConsignatario", {
      params: args,
    });
    return data.data.data;
  } catch (error: any) {
    throw new Error(error.response.data.Message);
  }
});

export const listarAnexosConsignatario = createAsyncThunk("/PrestacaoContaConsignatario/ListarAnexosConsignatario", async (args: BuscaAnexoConsignatarioModel) => {
  try {
    const data = await api.get("/PrestacaoContaConsignatario/ListarAnexosConsignatario", {
      params: args,
    });
    return data.data.data;
  } catch (error: any) {
    throw new Error(error.response.data.Message);
  }
});

export const buscarSaldoInicioFimConsignatario = createAsyncThunk("/PrestacaoContaConsignatario/BuscarSaldoInicioFimConsignatario", async (args: BuscarSaldoInicioFimConsignatarioModel) => {
  try {
    const data = await api.get("/PrestacaoContaConsignatario/BuscarSaldoInicioFimConsignatario", {
      params: args,
    });
    return data.data.data;
  } catch (error: any) {
    throw new Error(error.response.data.Message);
  }
});

export const listarAnexosPrestacaoContaConsignatario = createAsyncThunk("/PrestacaoContaConsignatario/ListarAnexosPrestacaoContaConsignatario", async (idVendaConsignatario: number) => {
  try {
    const data = await api.get("/PrestacaoContaConsignatario/ListarAnexosPrestacaoContaConsignatario", {
      params: { idVendaConsignatario: idVendaConsignatario },
    });
    return data.data.data;
  } catch (error: any) {
    throw new Error(error.response.data.Message);
  }
});
